import React from 'react'
import RechargeButton from './rechargebutton';

const Package = ({id, amount, title, description, validity, no_of_orders, history }) => (
    <div className="col-md-3 m-b-10">
        <div className="panel panel-default text-center">
            <div className="panel-heading">
                <h3>{title}</h3>
                <h2 className="price text-primary"> &#8377;{amount}</h2>
            </div>
            <ul className="list-group">
                <li className="list-group-item">{description}</li>
                {validity && <li className="list-group-item">Valid for {validity} days</li>}
                <li className="list-group-item">Upto {no_of_orders} orders</li>
            </ul>
            <div className="panel-body">
                <RechargeButton id={id} history={history}/>
            </div>
        </div>
    </div>
)

export default Package
